import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import "./SidebarStyleSheet/MFCentralSidebarFooter.scss";
import { EScreenState } from "@frameworks/arn-transfer/constants/constant";
import { useNavigate } from "react-router-dom";
var MFCentralSidebarFooter = function (props) {
    var navigate = useNavigate();
    var handleInitiateToTransferInProceedClick = function () {
        navigate("/dashboard/mf-transfer/transfer-in?details=".concat(btoa(JSON.stringify(props === null || props === void 0 ? void 0 : props.clientInfoToBeSynced))), { replace: true });
    };
    var syncSuccessBtn = function () {
        return (React.createElement(EdButton, { btnTyp: "tomato-filled-rounded", value: "Initiate Transfer-In to Nuvama", className: "", type: "button", onClick: handleInitiateToTransferInProceedClick }));
    };
    var syncFailureBtn = function () {
        return (React.createElement(EdButton, { btnTyp: "tomato-filled-rounded", value: "Sync Again", className: "sync-again text-nowrap", type: "button", onClick: function () {
                props === null || props === void 0 ? void 0 : props.setCurrentScreen(EScreenState.GENERATE_OTP);
                props === null || props === void 0 ? void 0 : props.setIsReadyToProceed(false);
                props === null || props === void 0 ? void 0 : props.setIsShowOtpField(false);
                props === null || props === void 0 ? void 0 : props.setOtpTimer(false);
                props === null || props === void 0 ? void 0 : props.setInputDisabled(false);
            } }));
    };
    var otpGenerationBtn = function () {
        return (React.createElement(React.Fragment, null,
            " ",
            React.createElement(EdButton, { btnTyp: "text-only", value: "Cancel", className: "cancel-btn", type: "button", onClick: function () {
                    props === null || props === void 0 ? void 0 : props.setOpenSidebar(false);
                    props === null || props === void 0 ? void 0 : props.setMobileFieldError("");
                    props === null || props === void 0 ? void 0 : props.setCurrentScreen(EScreenState.GENERATE_OTP);
                    props === null || props === void 0 ? void 0 : props.setIsReadyToProceed(false);
                    props === null || props === void 0 ? void 0 : props.setIsShowOtpField(false);
                    props === null || props === void 0 ? void 0 : props.setOtpTimer(false);
                    props === null || props === void 0 ? void 0 : props.setInputDisabled(false);
                    props === null || props === void 0 ? void 0 : props.setIsOtpError("");
                } }),
            React.createElement(EdButton, { btnTyp: (props === null || props === void 0 ? void 0 : props.isReadyToProceed) ? "tomato-filled-rounded" : "text-only", value: "Proceed", className: !(props === null || props === void 0 ? void 0 : props.isReadyToProceed) && "proceed-btn", type: "button", onClick: function () {
                    props === null || props === void 0 ? void 0 : props.getMfCenterDataToProcced();
                } }),
            " "));
    };
    var generatesButton = function () {
        switch (props.currentScreen) {
            case EScreenState.SYNC_SUCCESS:
                return syncSuccessBtn();
            case EScreenState.SYNC_FAILURE:
                return syncFailureBtn();
            case EScreenState.GENERATE_OTP:
                return otpGenerationBtn();
        }
    };
    return React.createElement("div", { className: "mf-central-sidebar-footer" }, generatesButton());
};
export default MFCentralSidebarFooter;
